export const sortingOptions = [
  { name: "Newest first", value: "newest" },
  { name: "Oldest first", value: "oldest" }
];
